import {
  BoilWaterIcon,
  CommemorationEventsIcon,
  EventIcon,
  HolidaysIcon,
  JobPostingsIcon,
  MeetingAnnouncementIcon,
  OfficeHoursIcon,
  ProjectBidIcon,
  RoadClosureIcon,
  SpecialProjectsIcon,
  WeatherAlertIcon,
  WeatherUpdateIcon,
  WelcomeIcon,
} from "../../../../../../../global/components/icons/notify";

export const NotifyNotificationsTemplates = [
  {
    card: {
      icon: WelcomeIcon,
      title: "Welcome",
    },
    template: {
      headline: "Welcome to [app name]!",
      tagline: "Thank you for downloading our app!",
      body: "![launch alert, preview of mobile app](https://assets.govoutreach.com/static/notify/Welcome.jpg)\n##### Thank you for downloading our app!\n\nKeep an eye out for news and alerts from [city/town/village/county].",
    },
  },
  {
    card: {
      icon: EventIcon,
      title: "Events",
    },
    template: {
      headline: "[Event] at the [location]!",
      tagline: "Join us for [event] at [location] on [insert date].",
      body: "![park on a sunny day](https://assets.govoutreach.com/static/notify/Event.jpg)\n##### On [date] from [time] to [time], bring your family and friends to [location] for [activity].\n\nEnjoy a variety of activities including [insert examples]. It’s a perfect opportunity to relax and spend quality time with your loved ones.\n\nThis event is FREE and open to the public.",
    },
  },
  {
    card: {
      icon: CommemorationEventsIcon,
      title: "Commemoration Events",
    },
    template: {
      headline: "[Commemoration event]!",
      tagline: "Join us for [commemoration event] at [location] on [insert date].",
      body: "![american flag](https://assets.govoutreach.com/static/notify/CommemorationEvent.jpg)\n\nOn [date] from [time] to [time], please join us to celebrate [commemoration event]! In honor of [commemoration event] we will be [insert activities].\n\nThis event is FREE and open to the public.",
    },
  },
  {
    card: {
      icon: SpecialProjectsIcon,
      title: "Special Projects",
    },
    template: {
      headline: "[Special project title] scheduled to start on [date]!",
      tagline: "[Special project title] will begin on [date], located at [location].",
      body: "![shovel in gravel](https://assets.govoutreach.com/static/notify/SpecialProject.jpg)\n##### On [date] we will begin our [special project title] project.\n\nWe apologize for any inconvenience this may cause and appreciate your patience while we try to make improvements to our [city/town/village/county]!",
    },
  },
  {
    card: {
      icon: OfficeHoursIcon,
      title: "Office Hours",
    },
    template: {
      headline: "City Hall closed due to [reason]",
      tagline: "City offices will be closed until [date].",
      body: "![front of city hall](https://assets.govoutreach.com/static/notify/OfficeHours.jpg)\n\nCity offices will be closed until [date].\n\nPlease use our app to report any issues and our team will respond.",
    },
  },
  {
    card: {
      icon: MeetingAnnouncementIcon,
      title: "Meeting Announcements",
    },
    template: {
      headline: "[Month and Year] City Council Meeting",
      tagline: "Our [Month and Year] City Council Meeting is scheduled to be held on [date] at [time], at [location].",
      body: "![city council meeting hall](https://assets.govoutreach.com/static/notify/MeetingAnnouncement.jpg)\n\nOur [Month and Year] City Council Meeting is scheduled to be held on [date] at [time], at [location].\n\nThis meeting is open to the public and all are welcome to attend.",
    },
  },
  {
    card: {
      icon: ProjectBidIcon,
      title: "Project Bids",
    },
    template: {
      headline: "[City/Town/Village/County] Bid Item ",
      tagline: "[Insert Project Name]",
      body: "![stacked paper documents](https://assets.govoutreach.com/static/notify/ProjectBid.jpg)\n\nAn opportunity to bid on a new [insert department] project has been posted on our website for [insert project name].\n\nTo bid on this opportunity please [insert instructions to bid].",
    },
  },
  {
    card: {
      icon: WeatherAlertIcon,
      title: "Weather Alerts",
    },
    template: {
      headline: "Winter Storm Warning",
      tagline: "Expect [weather conditions]; [#] inches of snow expected.",
      body: "![a car's headlights in blizzard conditions](https://assets.govoutreach.com/static/notify/WeatherAlert.jpg)\n\nA major winter storm will be hitting our area on [date]. Please use caution if you have to travel.\n\nWe are expecting up to [#] of snow. The [city/town/village/county] has declared a snow emergency for [amount of time].",
    },
  },
  {
    card: {
      icon: WeatherUpdateIcon,
      title: "Weather Updates",
    },
    template: {
      headline: "UPDATE: [Road/Street/Highway/Location] is closed due to [reason]",
      tagline: "[Road/Street/Highway/Location] is closed until further notice.",
      body: "![cartoon cloud, rain, and lighting icon](https://assets.govoutreach.com/static/notify/WeatherUpdate.jpg)\n\nDue to [reason], [Road/Street/Highway/Location] is closed until further notice.\n\nWe will alert you when it is re-opened, so please check back for updates.",
    },
  },
  {
    card: {
      icon: BoilWaterIcon,
      title: "Boil Water Advisories",
    },
    template: {
      headline: "Boil Water Advisory",
      tagline: "Boil Water Advisory for [date]",
      body: "![pot of water on stove](https://assets.govoutreach.com/static/notify/BoilWater.jpg)\n\nA boil water advisory is currently in effect for water customers in [city/town/village/county].\n\nWe anticipate the Boil Water Advisory will be lifted on [date]. Please check back for updates. Thank you for your patience and understanding.",
    },
  },
  {
    card: {
      icon: RoadClosureIcon,
      title: "Road Closures",
    },
    template: {
      headline: "Road Closure Notice",
      tagline: "Road closure between [road] and [road].",
      body: "![construction road barrier](https://assets.govoutreach.com/static/notify/RoadClosure.jpg)\n\nRoads are closed between [road] and [road] due to [event].\n\nPlease use alternate routes and expect delays. We apologize for any inconvenience this may cause and appreciate your patience.",
    },
  },
  {
    card: {
      icon: HolidaysIcon,
      title: "Holidays",
    },
    template: {
      headline: "Happy Holidays from [city/town/village/county]!",
      tagline: "[City/Town/Village/County] wishes you happy holidays!",
      body: "![launch alert, preview of mobile app](https://assets.govoutreach.com/static/notify/Holidays.jpg)\n\nOur staff at [city/town/village/county] want to wish you and your family happy holidays!",
    },
  },
  {
    card: {
      icon: JobPostingsIcon,
      title: "Job Postings",
    },
    template: {
      headline: "Position available in our [department/office]",
      tagline: "Details: [Type of Position]",
      body: "![we are hiring sign on brick wall](https://assets.govoutreach.com/static/notify/JobPosting.jpg)\n\nCity/Town/Village/County] is seeking a qualified candidate to become a part of our team at [department/office].\n\nThis position will [insert job duties].\n\nThis position is [full-time/part-time/seasonal] and is excepted to work approximately [#] hours per week.\n\nCandidates must [insert requirements].\n\nIf you are interested in this position and meet the qualifications outlined above, then please submit an application [application information] no later than [date].",
    },
  },
].map((template, index) => ({ ...template, id: index }));
